<template>
    <section class="relative">
            <div class="container-fluid relative">
                <div class="grid grid-cols-1">
                    <div class="flex flex-col min-h-screen justify-center md:px-10 pt-10 px-4">
                        <div class="title-heading text-center my-auto">
                            <img src="../assets/images/error.png" class="mx-auto" alt="">
                            <h1 class="mt-3 mb-6 md:text-4xl text-3xl font-bold">Pagina niet gevonden.</h1>
                            <p class="text-slate-400">Oeps, dat is niet juist.<br>Deze pagina bestaat niet.</p>
                            
                            <div class="mt-4">
                                <router-link to="/" class="btn bg-amber-100 hover:bg-amber-400 border-amber-300 hover:border-amber-400 text-zinc-700 rounded-md">Breng me terug</router-link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
</template>

<script>
    export default {
        data() {
            return {
                date: new Date().getFullYear(),
            }
        },
    }
</script>

<style lang="scss" scoped>

</style>